/** @format */

import { createContext } from "react";

/** Groups permitted to access the /admin area. */
export const ADMIN_GROUPS = ["admin", "content", "sme"] as const;

export interface User {
	sub: string;
	// eslint-disable-next-line @typescript-eslint/naming-convention
	given_name: string;
	// eslint-disable-next-line @typescript-eslint/naming-convention
	family_name: string;
	email: string;
	group?: string;
}

interface AuthContextProps {
	user: User | null;
	login: () => void;
	logout: () => Promise<void>;
	isAuthenticated: boolean;
	isLoading: boolean;
	/** True once a request was rejected because the session expired mid-use. */
	isSessionExpired: boolean;
	error: string | null;
}

export const AuthContext = createContext<AuthContextProps | undefined>(undefined);
